/* Safra mobile sticky bar: shows whenever #buy is off-screen (not yet reached, or scrolled past). */
if (!customElements.get('sf-sticky-cta')) {
  class SfStickyCta extends HTMLElement {
    connectedCallback() {
      const target = document.querySelector(this.dataset.watch || '#buy');
      this.hidden = false;
      if (!target || !('IntersectionObserver' in window)) {
        this.classList.add('is-visible');
        return;
      }
      this.observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          this.classList.toggle('is-visible', !entry.isIntersecting);
        },
        { threshold: 0 }
      );
      this.observer.observe(target);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }
  customElements.define('sf-sticky-cta', SfStickyCta);
}
